import { sizes } from '../../const/sizes';
export const SPINNER_SIZE_MAP = {
    small: sizes.spinner.small,
    medium: sizes.spinner.medium,
    large: sizes.spinner.large,
};
